export default "assets/images/logo-29cb0ce5.png";